import React from 'react';
import { InputNumber } from '@components/framework/input/InputNumber';
import CurrencyDropdown from '@components/ringil3/Input/InputPriceWithCurrency/CurrencyDropdown';

interface ComponentProps {
  value: number;
  currency: string;
  disabled?: boolean;
  disabledCurrency?: boolean;
  changePrice: (price: number) => void;
  changeCurrency: (currencyCode: string) => void;
}

const InputPriceWithCurrency: React.FC<ComponentProps> = ({
  currency,
  value,
  changePrice,
  changeCurrency,
  disabled = false,
  disabledCurrency = false,
}) => {
  return (
    <>
      <div className={'flex flex-row min-h-[40px]'}>
        <InputNumber
          className="p-text-right"
          minFractionDigits={2}
          maxFractionDigits={2}
          value={value}
          onChange={e => changePrice(e.value)}
          mode="decimal"
          disabled={disabled}
          locale={'cs'}
          inputStyle={{ textAlign: 'right', borderRight: 'none', width: '100%' }}
        />
        <CurrencyDropdown
          selectedCurrency={currency}
          onSelected={value => changeCurrency(value)}
          disabled={disabled || disabledCurrency}
          required={true}
          style={{ width: '100px', height: '40px' }}
        />
      </div>
    </>
  );
};

export default InputPriceWithCurrency;
